(function ($) {


    $(document).on('click', '.followme-tours-single-select-li', function () {
        var thisElement = $(this);

        if (!thisElement.hasClass('active')) {
            $(".followme-tours-single-content-tab").addClass('no-display');
            $("#" + thisElement.attr('data-id')).removeClass("no-display");

            $(".followme-tours-single-select-li").removeClass("active");
            $(this).addClass("active");
        }

    });


    $(document).on('click', '.tours-sidebar-opinie', function () {
        $(".followme-tours-single-select-li-comments").trigger('click');
    });


    $(document).on('click', '.tours-sidebar-termin-open-select-another', function () {
        $(".tours-sidebar-termin-inneterminy").toggle();
        $(".termin-select-another").find('.fas').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');
    });


    $(document).on('click', '.tours-sidebar-termin-inneterminy-termin', function () {
        $(".tours-sidebar-termin-inneterminy-termin").removeClass("active");
        $(this).addClass("active");
        $(".termin-current-date").attr('data-date-from', $(this).attr('data-date-from'));
        $(".termin-current-date").attr('data-date-to', $(this).attr('data-date-to'));
        $(".termin-current-date").html($(this).html());
        $(".tours-sidebar-termin-inneterminy").toggle();
        $(".termin-select-another").find('.fas').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');

        var sidebarUrl = $(".sidebar-tours-url");
        var newUrl = sidebarUrl.attr('data-primary') + '/' + $(this).attr('data-date-from') + '/' + $(this).attr('data-date-to') + "?lang" + $("body").attr("data-lang");

        sidebarUrl.attr('href', newUrl);


    });


    $(document).on('submit', '#commentform', function (e) {
        var thisElement = $(this);
        var error = false;

        thisElement.find(".error-message").remove();
        var imieElement = thisElement.find("#imie");
        var authorElement = thisElement.find("#author");
        var emailElement = thisElement.find("#email");
        var terminElement = thisElement.find("#termin");
        var commentElement = thisElement.find("#comment");
        var ratingElement = thisElement.find("input[name=rating]:checked");


        if (imieElement.val() === "") {
            imieElement.after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (authorElement.val() === "") {
            authorElement.after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (emailElement.val() === "") {
            emailElement.after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (terminElement.val() === "") {
            terminElement.after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (commentElement.val() === "") {
            commentElement.after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (typeof ratingElement.val() === 'undefined' || ratingElement.val() === null || ratingElement.val() === "") {
            $(".comments-rating").after('<div class="error-message">' + opinionsTranslate.uzupelnijpole + '</div>');
            error = true;
        }

        if (error) {
            e.preventDefault();
        }
    });

})(jQuery);